// extracted by mini-css-extract-plugin
export var gif = "_ln-0";